// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2mXSr","label":"styles_label__3UYHf"};